import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getProperty } from '../propertyEndpoints'

export function usePropertyQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.detail(toValue(id)),
    queryFn: () => getProperty(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
